module.exports = __webpack_public_path__ + "static/lawadvisor-screencast-d2301b86e2d5ee322876d19420f34670.mp4";